// extracted by mini-css-extract-plugin
export default {"NotFound":"notFound_NotFound__WhN7W"};